<template>
    <div class="planList">
        <table class="recordTable">
            <tbody>
            <tr class="title">
                <th>主题名称</th>
                <th width="230px">规划时间</th>
                <th width="300px">操作</th>
            </tr>
            <tr  v-for="(value,index) in planList" :key="index" >
                <td>{{value.interviewTheme}}</td>
                <td>{{value.interviewTime}}</td>
                <td class="btnBox">
                    <div>
                        <span class="goView" @click="goDetail(value)">查看</span>
                        <template v-if="userType==3">
                            <span class="goView chakan" v-if="pageData.current==1&&index==0" @click="$router.push({path:'/consultant/minestudent/main/planningContent/planningAdjustment',query:{id: value.id,num:pageData.total}})">规划调整</span>
                            <span class="chakan"  v-else style="color:#666;cursor:not-allowed">规划调整</span>
                        </template>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "planList",
    props:['userType','planList','pageData'],
    components: {
    },
    data() {
        return {
            // userType: 1,
            // planList: [{
            //     "id": 6,
            //     "lastId": 5,
            //     "studentId": 1,
            //     "interviewTheme": "规划内容1次调整",
            //     "interviewTime": "2020-12-31 16:32:23"
            // }],
            // pageData: {
            //     current:1,//当前页
            //     pageSize:10,//每页多少条
            //     totalPage:1,//总页数数
            //     total:1//总条数
            // }
        }
    },
    methods: {
        goDetail(value) {

            if(this.userType==1) {
                if(!value.lastId) {
                    this.$router.push({path:'/studyPlan/planningContent/planningReport',query:{id: value.id}})
                }else {
                    this.$router.push({path:'/studyPlan/planningContent/adjustmentReport',query:{id: value.id,lastId:value.lastId,interviewTheme:value.interviewTheme}})
                }
            }
            if(this.userType==2) {
                if(!value.lastId) {
                    this.$router.push({path:'/parent/main/planningContent/planningReport',query:{id: value.id}})
                }else {
                    this.$router.push({path:'/parent/main/planningContent/adjustmentReport',query:{id: value.id,lastId:value.lastId,interviewTheme:value.interviewTheme}})
                }
            }
            if(this.userType==3) {
                if(!value.lastId) {
                    this.$router.push({path:'/consultant/minestudent/main/planningContent/planningReport',query:{id: value.id}})
                }else {
                    this.$router.push({path:'/consultant/minestudent/main/planningContent/adjustmentReport',query:{id: value.id,lastId:value.lastId,interviewTheme:value.interviewTheme}})
                }
            }
        }
    }

}
</script>
<style scoped lang="less">
.planList {
    .recordTable {
        width: 100%;
        .title {
            font-size: 16px;
            border-radius: 5px;
            background: rgba(61, 144, 246, 0.2);
        }
        th {
            text-align: center;
            font-weight: bold;
        }
        tr {
            text-align: center;
            line-height: 40px;
            text-align: center;
            border-bottom: 1px solid #ECECEC;
        }
        .btnBox {
            display: flex;
            justify-content: center;
            align-items: center;
            div {
                width: 140px;
                display: flex;
                justify-content: center;
                .chakan {
                    margin-left: 40px;
                }
            }
            .goView {
                color: #3D90F6;
                cursor: pointer;
            }
        }
    }
}
</style>